"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _Authentication = require("../../provider/Authentication");

var _Profile = require("../../provider/Profile");

var _Button = _interopRequireDefault(require("@jobmatchme/ui/es/components/styleguide/Button"));

var _ArrowForwardIos = _interopRequireDefault(require("@material-ui/icons/ArrowForwardIos"));

var _Tracking = require("@jobmatchme/tracking/es/provider/Tracking");

var _Onboarding = require("@jobmatchme/ui/es/components/styleguide/Onboarding");

var _ModalDialog = _interopRequireDefault(require("@jobmatchme/ui/es/components/ModalDialog"));

var _ArrowBackIos = _interopRequireDefault(require("@material-ui/icons/ArrowBackIos"));

var _reactI18next = require("react-i18next");

var _Grid = _interopRequireDefault(require("@material-ui/core/Grid"));

var _Judgements = require("../../provider/Judgements");

var _styleModule = _interopRequireDefault(require("./style.module.scss"));

var _jsxRuntime = require("react/jsx-runtime");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var translateNs = 'pc-matching:Footer';

var FooterNavigation = function FooterNavigation(_ref) {
  var index = _ref.index,
      loaded = _ref.loaded,
      scrollTo = _ref.scrollTo,
      matchMeta = _ref.matchMeta,
      handleNext = _ref.handleNext,
      handlePrev = _ref.handlePrev,
      _ref$stepsCount = _ref.stepsCount,
      stepsCount = _ref$stepsCount === void 0 ? 0 : _ref$stepsCount,
      currentMatchId = _ref.currentMatchId,
      currentDiscriminator = _ref.currentDiscriminator,
      currentMatchRevision = _ref.currentMatchRevision,
      currentProfileRevision = _ref.currentProfileRevision,
      _ref$onJudgement = _ref.onJudgement,
      onJudgement = _ref$onJudgement === void 0 ? function () {} : _ref$onJudgement,
      _ref$navigationDisabl = _ref.navigationDisabled,
      navigationDisabled = _ref$navigationDisabl === void 0 ? false : _ref$navigationDisabl,
      _ref$judgementsDisabl = _ref.judgementsDisabled,
      judgementsDisabled = _ref$judgementsDisabl === void 0 ? false : _ref$judgementsDisabl;

  var _useTranslation = (0, _reactI18next.useTranslation)(),
      t = _useTranslation.t;

  var _useComponentTracking = (0, _Tracking.useComponentTracking)('FooterNavigation'),
      pcDataLayerPush = _useComponentTracking.pcDataLayerPush;

  var profile = (0, _react.useContext)(_Profile.ProfileContext);
  var judgementsActions = (0, _react.useContext)(_Judgements.JudgementsActionsContext);

  var _useContext = (0, _react.useContext)(_Authentication.AuthenticationContext),
      isAuthenticated = _useContext.isAuthenticated;

  var _useContext2 = (0, _react.useContext)(_Onboarding.OnboardingContext),
      runOnboarding = _useContext2.runOnboarding,
      resetOnboarding = _useContext2.resetOnboarding;

  var _useState = (0, _react.useState)(true),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      alertDialogOpeningStatus = _useState2[0],
      setAlertDialogOpeningStatus = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      optimisticJudgementDisabled = _useState4[0],
      setOptimisticJudgementDisabled = _useState4[1];

  var source = 'matchLike';

  var judgeLike = function judgeLike() {
    onJudgement(_Judgements.MATCH_STATE_LIKE, currentMatchId);
    judgementsActions.judgeMatch(_Judgements.MATCH_STATE_LIKE, currentMatchId, currentMatchRevision, currentProfileRevision, source, matchMeta);
    setOptimisticJudgementDisabled(true); // Send to GA

    pcDataLayerPush('like', profile, 'pc_app');
    setIsButtonVisible(false);
    resetOnboarding();
    scrollToTop();
  };

  var judgeDislike = function judgeDislike() {
    onJudgement(_Judgements.MATCH_STATE_DISLIKE, currentMatchId);
    judgementsActions.judgeMatch(_Judgements.MATCH_STATE_DISLIKE, currentMatchId, currentMatchRevision, currentProfileRevision, source, matchMeta);
    setOptimisticJudgementDisabled(true);
    setIsButtonVisible(false); // Send to GA

    pcDataLayerPush('dislike', profile, 'pc_app');
    scrollToTop();
  };

  var scrollerPath = 'offerDescription' + index;

  var _useState5 = (0, _react.useState)(true),
      _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
      isButtonVisible = _useState6[0],
      setIsButtonVisible = _useState6[1];

  var listener = function listener(e) {
    if (typeof window != 'undefined' && window.document && document.getElementById(scrollerPath) !== null) {
      var _document, _document$getElementB, _document$getElementB2;

      var elemYPos = ((_document = document) === null || _document === void 0 ? void 0 : (_document$getElementB = _document.getElementById(scrollerPath)) === null || _document$getElementB === void 0 ? void 0 : (_document$getElementB2 = _document$getElementB.getBoundingClientRect()) === null || _document$getElementB2 === void 0 ? void 0 : _document$getElementB2.top) || 0;

      if (elemYPos < 300) {
        if (isButtonVisible) {
          setIsButtonVisible(false);
        }
      } else {
        if (!isButtonVisible) {
          setIsButtonVisible(true);
        }
      }
    }
  };

  var scrollToTop = function scrollToTop() {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
    return;
  };

  (0, _react.useEffect)(function () {
    window.addEventListener('scroll', listener);
    return function () {
      window.removeEventListener('scroll', listener);
    };
  }); // revert setOptimisticJudgementDisabled when has changed

  (0, _react.useEffect)(function () {
    setOptimisticJudgementDisabled(false);
  }, [judgementsDisabled]);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: _styleModule.default.footer,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_Grid.default, {
      container: true,
      spacing: 2,
      className: _styleModule.default.btnWrapper,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Grid.default, {
        item: true,
        xs: 6,
        className: _styleModule.default.gridItem,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.default, {
          round: true,
          flat: true,
          extraBold: true,
          fullWidth: true,
          id: "disLikeBtn",
          color: "danger",
          variant: "contained",
          texttransform: "none",
          className: _styleModule.default.saveBtn,
          onClick: judgeDislike,
          disabled: judgementsDisabled || !isAuthenticated || optimisticJudgementDisabled,
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            className: _styleModule.default.bold,
            children: t("".concat(translateNs, ".dislike"))
          })
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Grid.default, {
        item: true,
        xs: 6,
        className: _styleModule.default.gridItem,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.default, {
          flat: true,
          round: true,
          fullWidth: true,
          extraBold: true,
          id: "likeBtn",
          color: "success",
          variant: "contained",
          texttransform: "none",
          className: _styleModule.default.saveBtn,
          onClick: judgeLike,
          disabled: judgementsDisabled || !isAuthenticated || optimisticJudgementDisabled,
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            className: _styleModule.default.bold,
            children: t("".concat(translateNs, ".like"))
          })
        })
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Grid.default, {
      container: true,
      spacing: 0,
      className: "".concat(_styleModule.default.border, " ").concat(_styleModule.default.buttons),
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Grid.default, {
        item: true,
        xs: 5,
        className: "".concat(_styleModule.default.gridItem, " ").concat(_styleModule.default.alignLeft),
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.default, {
          flat: true,
          round: true,
          extraBold: true,
          variant: "text",
          texttransform: "none",
          onClick: function onClick() {
            scrollToTop();
            handlePrev();
            setOptimisticJudgementDisabled(false);
          },
          disabled: index > 0 && navigationDisabled === false ? false : true,
          children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
            className: _styleModule.default.btn,
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_ArrowBackIos.default, {
              fontSize: "small"
            }), t("".concat(translateNs, ".prev"))]
          })
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Grid.default, {
        item: true,
        xs: 2,
        className: _styleModule.default.gridItem,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          className: _styleModule.default.counter,
          children: "".concat(index + 1, " ").concat(t('pc-matching:JobOffer.outOf'), " ").concat(stepsCount)
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Grid.default, {
        item: true,
        xs: 5,
        className: "".concat(_styleModule.default.gridItem, " ").concat(_styleModule.default.alignRight),
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.default, {
          flat: true,
          round: true,
          extraBold: true,
          variant: "text",
          texttransform: "none",
          onClick: function onClick() {
            scrollToTop();
            handleNext();
            setOptimisticJudgementDisabled(false);
          },
          children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
            className: _styleModule.default.btn,
            children: [t("".concat(translateNs, ".next")), /*#__PURE__*/(0, _jsxRuntime.jsx)(_ArrowForwardIos.default, {
              fontSize: "small"
            })]
          })
        })
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "".concat(_styleModule.default.showMore, " ").concat(_styleModule.default.animationRools, " ").concat(isButtonVisible ? _styleModule.default.btnVisible : _styleModule.default.btnHidden),
      onClick: function onClick() {
        scrollTo(scrollerPath, 0);
      },
      children: t('pc-matching:JobOffer.showMore')
    }), loaded && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_ModalDialog.default, {
      opacity: 0.5,
      oneOff: true,
      dialogActions: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.default, {
        round: true,
        flat: true,
        fullWidth: true,
        extraBold: true,
        color: "primary",
        disabled: false,
        id: "closeModalBtn",
        variant: "contained",
        texttransform: "none",
        className: "".concat(_styleModule.default.maxWidth90p),
        onClick: function onClick() {
          typeof window != 'undefined' && localStorage.setItem('likeBtnTooltip', 'true');
          setAlertDialogOpeningStatus(false);
          runOnboarding();
        },
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: _styleModule.default.bold,
          children: t("".concat(translateNs, ".closeModalBtn"))
        })
      }),
      showDividers: false,
      id: "likeBtnTooltip",
      name: "likeBtnTooltip",
      verticalMobilePosition: 'bottom',
      open: Boolean(alertDialogOpeningStatus),
      onClose: function onClose() {
        setAlertDialogOpeningStatus(false);
        runOnboarding();
      },
      title: t("".concat(translateNs, ".likeBtnModalTitle")),
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
        children: t("".concat(translateNs, ".likeBtnModalText"))
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
        children: t("".concat(translateNs, ".likeBtnModalText2"))
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Grid.default, {
        container: true,
        spacing: 0,
        className: "".concat(_styleModule.default.buttonPos),
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Grid.default, {
          item: true,
          className: "".concat(_styleModule.default.gridItem, " ").concat(_styleModule.default.alignCenter, " ").concat(_styleModule.default.maxWidth200),
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.default, {
            round: true,
            flat: true,
            fullWidth: true,
            extraBold: true,
            id: "likeBtn",
            color: "success",
            variant: "contained",
            texttransform: "none",
            className: _styleModule.default.demoBtn,
            disabled: true,
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
              className: _styleModule.default.bold,
              children: t("".concat(translateNs, ".like"))
            })
          })
        })
      })]
    })]
  });
};

var _default = /*#__PURE__*/(0, _react.memo)((0, _reactI18next.withTranslation)()(FooterNavigation));

exports.default = _default;